var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',[_c('div',{staticClass:"NotFoundPage"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Страница не существует!")]),_c('router-link',{attrs:{"to":"/"}},[_c('ButtonSecondary',[_vm._v(" Перейти на главную ")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }